import {
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  Fade,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  makeStyles,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import CloseModalButton from "Admin/Common/CloseModalButton";
import GeneralSebiActivities from "Admin/Sebi/GeneralSebiActivities";
import instance from "api/globalaxios";
import { useSnackbar } from "contexts/SnackbarContext";
import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import FormattedMessage from "features/common/TranslatedMessage";
import { DropzoneDialog } from "material-ui-dropzone";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Popup from "reactjs-popup";
import { getRealhost } from "slices/disputeSlice";
import { isArb, isMSME, isSebi, isTiac } from "Routes/Routes";
import {
  approvedDispute,
  CloseDisputeAtLevelTwo,
  downloadLegalDoc,
  gethost,
  tiacdoc,
  updateDispute,
  sendPaymentLinkRespondent
} from "slices/disputeSlice";
import { formatDate } from "utils";
import CaseDisplayProfileList from "./CaseDisplayProfileList";
import CaseManager from "./CaseManager";
import Company from "./Company";
import Complainant from "./Complainant";
import GRO from "./GRO";
import RespondentLawyer from "./Respondentlawyer";
import SRB from "./SRB";
import Summary from "./Summary";
import Witness from "./Witness";
import CaseAssignInput from "Admin/Sebi/CaseAssignInput";
import { closed_reason_choices } from "Admin/Sebi/CaseDisplay";
import { getAwardSharedDate, isNalsarTempEmail } from "../utils";
import { CLOSED, MEDIATOR } from "app/constants";

// Lets a long file name wrap at its _ . - separators instead of only at spaces.
function breakableFileName(name) {
  const text = String(name == null ? "" : name);
  const chunks = text.match(/[^_.\-\s]*[_.\-\s]+|[^_.\-\s]+/g) || [text];
  return chunks.map((chunk, index) => (
    <React.Fragment key={index}>
      {chunk}
      {index < chunks.length - 1 && <wbr />}
    </React.Fragment>
  ));
}

const useStyles = makeStyles((theme) => ({
  backbtn: {
    fontSize: "18px",
    lineHeight: "21px",
    letterSpacing: "0.4px",
    color: "#454545",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      lineHeight: "15px",
    },
  },
  blackheading: {
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "23px",
    letterSpacing: "0.4px",
    color: "#454545",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      lineHeight: "15px",
    },
  },
  bigbtn: {
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "36px",
    letterSpacing: "0.4px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      lineHeight: "15px",
    },
  },
  closedbtn: {
    background: "#E0E0E0",
    color: "white",
    "&:hover": {
      backgroundColor: "#E0E0E0",
    },
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "36px",
    letterSpacing: "0.4px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      lineHeight: "15px",
    },
  },
  blueheading: {
    fontWeight: "bold",
    fontSize: "20px",
    // lineHeight: "36px",
    color: "#2F80ED",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  awardpaper: {
    margin: "3rem auto",
    height: "80%",
    width: "50%",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
    outline: "none",
    borderRadius: "0.4rem",
    overflowY: "scroll",
    [theme.breakpoints.down("sm")]: {
      width: "70%",
      height: "80%",
      padding: "1rem",
    },
    [theme.breakpoints.down("xs")]: {
      width: "90%",
      height: "80%",
      padding: "0.5rem",
    },
  },
  awardModalPaper: {
    margin: "3rem auto",
    width: "100%",
    maxWidth: "720px",
    maxHeight: "85vh",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 4),
    textAlign: "center",
    outline: "none",
    borderRadius: "8px",
    boxSizing: "border-box",
    overflowY: "auto",
    overflowX: "hidden",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.18)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "92%",
      padding: theme.spacing(2, 2, 3),
    },
  },
  awardModalTitle: {
    // CloseModalButton floats right, so clear it to get a full-width line box
    // and a genuinely centred title rather than one nudged off-centre.
    clear: "both",
    fontSize: "1.25rem",
    fontWeight: 600,
    color: "#333333",
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.05rem",
    },
  },
  // Every table property is pinned here with descendant selectors: Analytics.css
  // has unscoped table/th/td rules that would otherwise restyle this table.
  awardTableWrap: {
    width: "100%",
    boxSizing: "border-box",
    marginTop: "1.5rem",
    border: "1px solid #E5E5E5",
    borderRadius: "8px",
    // TableContainer defaults to overflowX: auto; the columns are all
    // percentage-based and the names wrap, so nothing needs to scroll.
    overflowX: "hidden",
    "& table": {
      width: "100%",
      maxWidth: "100%",
      height: "auto",
      margin: 0,
      marginTop: 0,
      borderCollapse: "collapse",
      // Fixed layout stops a long file name from stretching the other columns.
      tableLayout: "fixed",
      fontFamily: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
    },
    "& th, & td": {
      border: "none",
      padding: "12px 16px",
      fontSize: "0.9rem",
      color: "#4F4F4F",
      verticalAlign: "middle",
    },
    "& thead th": {
      backgroundColor: "#F5F5F7",
      color: "#333333",
      fontWeight: 600,
      fontSize: "0.75rem",
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      whiteSpace: "nowrap",
      borderBottom: "1px solid #E5E5E5",
    },
    "& tbody tr + tr td": {
      borderTop: "1px solid #F0F0F0",
    },
    "& tbody tr:hover": {
      backgroundColor: "#FAFAFB",
    },
    [theme.breakpoints.down("xs")]: {
      "& th, & td": {
        padding: "10px 8px",
        fontSize: "0.8rem",
      },
      "& thead th": {
        fontSize: "0.75rem",
      },
    },
  },
  awardDocName: {
    display: "block",
    fontSize: "inherit",
    fontWeight: 500,
    color: theme.palette.primary.main,
    cursor: "pointer",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    lineHeight: 1.45,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  awardShareBtn: {
    fontSize: "0.8rem",
    fontWeight: 500,
    textTransform: "none",
    padding: "2px 6px",
    minWidth: "auto",
  },
  awardSharedChip: {
    height: "22px",
    fontSize: "0.75rem",
    fontWeight: 500,
    color: "#27AE60",
    backgroundColor: "#E7F5EC",
  },
  awardEmptyCell: {
    fontSize: "0.9rem",
    color: "#757575",
    padding: "2rem 8px",
  },
  awardDropzone: {
    margin: "1.5rem auto 0",
    maxWidth: "400px",
    padding: "1.25rem",
    border: "1px dashed #C9C9CF",
    borderRadius: "8px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    transition: "border-color 120ms ease, background-color 120ms ease",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: "#FAF7FB",
    },
  },
  awardDropzoneText: {
    fontSize: "0.85rem",
    color: "#757575",
    marginTop: "0.35rem",
  },
  awardSubmitBtn: {
    width: "224px",
    marginTop: "1.25rem",
    textTransform: "none",
    boxShadow: "none",
  },
  username: {
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.2px",
    color: "#252733",
  },
  activityText: {
    fontSize: "18px",
    fontWeight: 400,
    fontFamily: `'Inter',sans-serif`,
    color: "#4F4F4F",
  },
}));

function getNewCasefiles(dispute_id) {
  return async () => {
    try {
      const response = await instance.get(
        `/tiacassigndessigncasefile/${dispute_id}`
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
}

export default function CaseDisplay({
  setOpenCase,
  isSmallScreen,
  caseId,
  mode,
  profile,
  reloadOverview,
}) {
  useEffect(() => {
    const body = document.querySelector("#root");
    body.scrollIntoView(
      {
        behavior: "auto",
      },
      500
    );
  }, []);

  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();

  let split_by = "vs";
  if (isSebi || isMSME) {
    split_by = "v.";
  }

  const updateDisputeName = () => {
    dispatch(getNewCasefiles(caseId)).then((res) => {
      let c_casefiles = [];
      let r_casefiles = [];
      res.map((item) => {
        if (item.type == "claimant") c_casefiles.push(item);
        else r_casefiles.push(item);
      });
      c_casefiles.sort(function (a, b) {
        var nameA = a.id;
        var nameB = b.id;
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      r_casefiles.sort(function (a, b) {
        var nameA = a.id;
        var nameB = b.id;
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });

      let name = "";
      if (c_casefiles.length > 1) {
        name +=
          c_casefiles[0].profile.user.first_name +
          " " +
          c_casefiles[0].profile.user.last_name +
          " and others " +
          split_by +
          " ";
      } else if (c_casefiles.length == 1) {
        if (c_casefiles[0].profile == null) {
          name += " " + split_by + " ";
        } else {
          name +=
            c_casefiles[0].profile.user.first_name +
            " " +
            c_casefiles[0].profile.user.last_name +
            " " +
            split_by +
            " ";
        }
      }

      if (r_casefiles.length > 1) {
        name +=
          r_casefiles[0].profile.user.first_name +
          " " +
          r_casefiles[0].profile.user.last_name +
          " and others";
      } else if (r_casefiles.length == 1) {
        if (r_casefiles[0].profile == null) {
          name += " " + split_by + " ";
        } else {
          name +=
            r_casefiles[0].profile.user.first_name +
            " " +
            r_casefiles[0].profile.user.last_name;
        }
      }

      dispatch(
        updateDispute({
          id: caseId,
          name: name,
        })
      ).then(() => {
        reloadOverview();
      });
    });
  };

  const [dispute, setDispute] = useState();
  const [isDisputeClosed, setIsDisputeClosed] = React.useState();
  const [startDate, setStartDate] = useState();
  const [approvedDate, setApprovedDate] = useState("---");
  const [summary, setSummary] = useState();
  const [complainantData, setcomplainantData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [groData, setgroData] = useState();
  const [lawyerData, setLawyerData] = useState();
  const [lawyerDataRV, setLawyerDataRV] = useState();
  const [casefiles, setCasefiles] = useState();
  const [witnessData, setwitnessData] = useState();
  const [casemanagerData, setCasemanagerData] = useState();
  const [allProfiles, setAllProfiles] = useState();
  const [loading, setLoading] = useState(true);
  const [loadingCaseClose, setLoadingCaseClose] = useState(false);

  const [allAssignedPrifiles, setallAssignedPrifiles] = useState([]);

  const [ClaimantLawyerData, setClaimantLawyerData] = useState([]);
  const [RespondentLawyerData, setRespondentLawyerData] = useState([]);

  const [commonFiles, setCommonFiles] = useState([]);
  const [decisions, setdecisions] = useState([]);
  const [activities, setActivities] = useState([]);
  const [successState, setSuccessState] = useState("unsuccessful");
  const [selectedUserId, setSelectedUserId]= useState("")

  const handleSuccessStateChange = (e) => {
    setSuccessState(e.target.value);
  };
  
  const handleSelectUserId = (e) => {
    setSelectedUserId(e.target.value);
  };

  const refresh = () => {
    dispatch(disputeDetails()).then(() => {});
    // dispatch(joinHearingRooms(caseId));
  };

  React.useEffect(() => {
    refresh();
  }, []);

  function disputeDetails() {
    return async () => {
      try {
        setLoading(true);
        const response = await instance.get(
          `/api/tiacrvdisputedetailsbyid/${caseId}/`
        );
        let response2 = await instance({
          method: "get",
          url: "/api/casefile/" + "?host=" + gethost(),
          params: {
            dispute__id: caseId,
          },
        });
        // if (isSebi || isMSME) {
        //   dispatch(getActivityByTabAndId('general',caseId)).then((res) => {
        //     setActivities(res);
        //   });
        // }
        let casefilesres = response2.data.results;
        setCasefiles(casefilesres);

        let casefile_respondent = [];
        let new_cl_lawyer = [];
        let new_rsp_lawyer = [];
        casefilesres.sort(function (a, b) {
          var nameA = a.id;
          var nameB = b.id;
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        let cl_index = 0;
        let resp_index = 0;
        casefilesres.forEach((casefile) => {
          if (casefile.type == "claimant") {
            casefile_respondent.push(casefile);
            if (casefile.lawyer_rv.length == 0) {
              new_cl_lawyer.push({
                index: cl_index,
                casefile: casefile,
                lawyer: null,
              });
            }
            casefile.lawyer_rv.forEach((i) => {
              new_cl_lawyer.push({
                index: cl_index,
                casefile: casefile,
                lawyer: i,
                all: casefile.lawyer_rv,
              });
            });
            cl_index += 1;
          } else {
            casefile_respondent.push(casefile);
            if (casefile.lawyer_rv.length == 0) {
              new_rsp_lawyer.push({
                index: resp_index,
                casefile: casefile,
                lawyer: null,
              });
            }
            casefile.lawyer_rv.forEach((i) => {
              new_rsp_lawyer.push({
                index: resp_index,
                casefile: casefile,
                lawyer: i,
                all: casefile.lawyer_rv,
              });
            });
            resp_index += 1;
          }
        });
        setClaimantLawyerData(new_cl_lawyer);
        setRespondentLawyerData(new_rsp_lawyer);

        let d = response.data;
        setDispute(d.dispute_data.dispute[0]);
        setCommonFiles(
          d.dispute_data.all_docs.filter((item) => item.is_rfa_rv)
        );
        setdecisions(d.dispute_data.all_docs.filter((item) => !item.is_rfa_rv));
        setIsDisputeClosed(d.dispute_data.dispute[0].status === CLOSED);
        setSummary(d.dispute_data.dispute[0].summery);
        setcomplainantData(d.dispute_data.claimant);
        if (d.dispute_data.respondent.length > 0)
          setCompanyData(d.dispute_data.respondent);
        else setCompanyData([]);
        let resArbitrator = [];
        let resLawyer = [];
        let resWitness = [];
        let professionals = d.dispute_data.professionals;
        professionals.forEach((item) => {
          if (
            item.profile.profile_type == "arbitrator" ||
            item.profile.profile_type == "arbitrator_rv" ||
            item.profile.profile_type == "mediator"
          ) {
            resArbitrator.push(item);
          } else if (
            item.profile.profile_type == "lawyer" ||
            item.profile.profile_type == "lawyer_rv"
          ) {
            resLawyer.push(item);
          } else if (
            item.profile.profile_type == "witness" ||
            item.profile.profile_type == "witness_rv"
          ) {
            resWitness.push(item);
          }
        });
        setgroData(resArbitrator);
        setLawyerData(resLawyer);
        setwitnessData(resWitness);
        setCasemanagerData(d.dispute_data.case_manager_rv);
        let resultProfiles = [];
        if (d.dispute_data.claimant.length > 0) {
          d.dispute_data.claimant.forEach((item) => {
            let r = item;
            r.profile.rv_profile = "Claimant";
            resultProfiles.push(r);
          });
        }
        if (d.dispute_data.respondent.length > 0) {
          d.dispute_data.respondent.forEach((item) => {
            let r = item;
            r.profile.rv_profile = "Respondent";
            resultProfiles.push(r);
          });
        }
        d.dispute_data.professionals.forEach((item) => {
          resultProfiles.push(item);
        });
        setAllProfiles(resultProfiles);
        let date;
        if (
          (isSebi || isMSME) &&
          d.dispute_data.dispute[0].flow_type === "arbitration"
        ) {
          date = new Date(
            d.dispute_data.dispute[0].converted_to_arbitration_at
          );
        } else {
          date = new Date(d.dispute_data.dispute[0].created);
        }
        setStartDate(formatDate(date));
        if (d.dispute_data.dispute[0].approved) {
          date = new Date(d.dispute_data.dispute[0].approved_date);
          setApprovedDate(formatDate(date));
        }
        let assignedProfiles = [];
        assignedProfiles = assignedProfiles
          .concat(d.dispute_data.claimant)
          .concat(d.dispute_data.respondent)
          .concat(resArbitrator)
          .concat(resLawyer)
          .concat(d.dispute_data.case_manager_rv)
          .concat(resWitness);
        setallAssignedPrifiles(assignedProfiles);
        setLoading(false);
        return response.data;
      } catch (error) {
        console.log(error);
      }
    };
  }

  const shareDecision = (id) => {
    return async () => {
      try {
        const response = await instance.put(
          "/tiacfinaldecession/" + id + "/?host=" + getRealhost(),
          { dispute_id: dispute.id },
          {
            headers: {
              Accept: "application/json",
              "Content-type": "application/json",
            },
          }
        );
      } catch (error) {
        console.log(error);
      }
    };
  };

  const [loadingRegisterApi, setLoadingRegisterApi] = useState(false);

  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [openRegister, setOpenRegister] = React.useState(false);
  const [openAwardFinal, setOpenAwardFinal] = useState(false);
  const openPopupAwardFinal = () => setOpenAwardFinal(true);
  const closeAwardFinal = () => {
    setOpenAwardFinal(false);
    setFiles([]);
    refresh();
  };
  const [openAwardPartial, setOpenAwardPartial] = useState(false);
  const openPopupAwardPartial = () => setOpenAwardPartial(true);
  const closeAwardPartial = () => {
    setOpenAwardPartial(false);
    setFiles([]);
    refresh();
  };

  const [loadingfiles, setLoadingfiles] = useState(false);
  const [openUpload, setOpenUpload] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const addFile = (file) => {
    files.push(file);
    setFiles(files);
  };
  const deleteFile = (index) => {
    let localFiles = [...files];
    localFiles.splice(index, 1);
    setFiles(localFiles);
  };

  const renderFiles = (files, deleteFile) => {
    return files.length !== 0
      ? files.map((file, index) => {
          return (
            <Box className={classes.itempaper}>
              <Box
                textAlign="center"
                position="relative"
                key={index}
                // display="flex"
                // justifyContent="center"
              >
                <Box>
                  <Typography
                    style={{ wordBreak: "break-all", paddingTop: "20px" }}
                    variant="subtitle2"
                  >
                    {file.name}
                  </Typography>
                  <IconButton
                    aria-label="delete"
                    color="primary"
                    onClick={() => {
                      deleteFile(index);
                    }}
                  >
                    <DeleteOutlineIcon style={{ color: "#2F80ED" }} />
                  </IconButton>
                </Box>
              </Box>
            </Box>
          );
        })
      : null;
  };

  function uploadDispute(files, activeDispute, type) {
    return async () => {
      const data = new FormData();
      files.forEach((file) => {
        data.append(file.name, file);
      });
      try {
        const response = await instance.put(
          "/uploaddispute/" + activeDispute.id + "/?award_type=" + type,
          data,
          {
            headers: {
              "content-type": "multipart/form-data",
            },
          }
        );
      } catch (error) {
        console.log(error);
      }
    };
  }

  const uploadDecision = (type) => {
    setLoadingfiles(true);
    dispatch(uploadDispute(files, dispute, type))
      .then(() => {
        setLoadingfiles(false);
        setFiles([]);
        if (type == "final_award") {
          closeAwardFinal();
        } else {
          closeAwardPartial();
        }
      })
      .catch(() => {
        setLoadingfiles(false);
      });
  };

  const [openRFA, setOpenRFA] = useState(false);

  const openPopupRFA = () => setOpenRFA(true);
  const closeRFA = () => {
    setOpenRFA(false);
    refresh();
  };

  const openpopup2 = () => {
    setOpen2(true);
  };

  const openpopup3 = () => {
    setOpen3(true);
  };

  const openpopupRegister = () => {
    setOpenRegister(true);
  };

  const closeModal2 = () => {
    setOpen2(false);
  };

  const closeModal3 = () => {
    setOpen3(false);
  };

  const closeModalRegister = () => {
    setOpenRegister(false);
  };

  const handleMoveToArbitration = async () => {
    try {
      setLoading(true);
      const response = await instance.post(
        `/sebi/convert_to_arbitration/${dispute.id}/`
      );
      setLoading(false);
      showSnackbar("Moved to Arbitration", "success");
      refresh();
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const ApproveDispute = () => {
    if (!loadingRegisterApi) {
      if (dispute.rv_tiac_payment_status == "complete") {
        setLoadingRegisterApi(true);
        dispatch(
          approvedDispute({
            id: caseId,
          })
        )
          .then(() => {
            closeModalRegister();
            refresh();
            reloadOverview();
          })
          .catch((error) => {
            console.log(error);
          })
          // stop the loader whether registration succeeded or not
          .then(() => {
            setLoadingRegisterApi(false);
          });
      } else {
        alert(
          "Please confirm that the Claimant has paid the registration fees before registering the arbitration."
        );
      }
    }
  };

  const closeGrievence = async () => {
    if(loadingCaseClose) return; // Prevent multiple clicks

    try {
      setLoadingCaseClose(true);
      if (isSebi || isMSME) {
        // Close the dispute first with successState
        await dispatch(CloseDisputeAtLevelTwo(caseId, successState));
  
        // Call sendPaymentLinkRespondent ONLY if isSebi is true
        if (isSebi && dispute?.flow_type === "mediation") {
          await sendPaymentLinkRespondent(dispute?.tiac_custom_dispute_id, successState, selectedUserId, dispute?.description);
        }
      } else {
        // Close dispute without successState
        await dispatch(CloseDisputeAtLevelTwo(caseId));
      }
  
      // Reload overview and update state
      reloadOverview();
      setIsDisputeClosed(true);
      setOpen2(false);
    } catch (error) {
      console.error("Error in closing grievance:", error);
    }
  };
  

  async function deleteDecisionId(id) {
    return await instance.delete(`/arbitrator_decisiondelete/${id}/`);
  }

  // Dropzone + SUBMIT for a new award; nothing can be added once the case is closed.
  const renderAwardUpload = (type) => {
    if (isDisputeClosed) return null;
    const submitDisabled = files.length < 1 || loadingfiles;
    return (
      <>
        {files.length === 0 && (
          <Box
            className={classes.awardDropzone}
            onClick={() => {
              setOpenUpload(true);
            }}
          >
            <AddCircleOutlineIcon color="primary" />
            <Typography className={classes.awardDropzoneText}>
              Add {type === "final_award" ? "final" : "partial"} award document
            </Typography>
          </Box>
        )}
        {renderFiles(files, deleteFile)}
        <Button
          variant="contained"
          color="primary"
          className={classes.awardSubmitBtn}
          onClick={() => {
            uploadDecision(type);
          }}
          disabled={submitDisabled}
        >
          {loadingfiles ? "SUBMITTING..." : "SUBMIT"}
        </Button>
        <DropzoneDialog
          cancelButtonText={"cancel"}
          submitButtonText={"submit"}
          maxFileSize={104857600}
          open={openUpload}
          onClose={() => setOpenUpload(false)}
          onSave={(files) => {
            files.forEach((file) => {
              addFile(file);
            });
            setOpenUpload(false);
          }}
          showPreviews={true}
          filesLimit={1}
          showFileNamesInPreview={true}
          acceptedFiles={[
            "image/jpeg",
            "image/png",
            "image/jpg",
            "application/msword",
            "application/pdf",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ]}
        />
      </>
    );
  };

  const renderAwardsTable = (type, closeModal) => {
    const awards = decisions.filter(
      (item) => !item.is_rfa_rv && item.award_type == type
    );
    return (
      <TableContainer className={classes.awardTableWrap}>
        <Table>
          <colgroup>
            <col style={{ width: "40%" }} />
            <col style={{ width: "18%" }} />
            <col style={{ width: "18%" }} />
            <col style={{ width: "14%" }} />
            <col style={{ width: "10%" }} />
          </colgroup>
          <TableHead>
            <TableRow>
              <TableCell>Document Name</TableCell>
              <TableCell>Upload Date</TableCell>
              <TableCell>Shared Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="center" />
            </TableRow>
          </TableHead>
          <TableBody>
            {awards.length === 0 ? (
              <TableRow>
                <TableCell
                  className={classes.awardEmptyCell}
                  colSpan={5}
                  align="center"
                >
                  No documents uploaded yet.
                </TableCell>
              </TableRow>
            ) : (
              awards.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>
                    <Typography
                      className={classes.awardDocName}
                      onClick={() => {
                        downloadLegalDoc(item.id);
                      }}
                    >
                      {breakableFileName(item.name)}
                    </Typography>
                  </TableCell>
                  <TableCell>{formatDate(item.created)}</TableCell>
                  <TableCell>
                    {item.is_final ? getAwardSharedDate(item) : "---"}
                  </TableCell>
                  <TableCell>
                    {item.is_final ? (
                      <Chip
                        size="small"
                        label="Shared"
                        className={classes.awardSharedChip}
                      />
                    ) : (
                      <Button
                        color="primary"
                        className={classes.awardShareBtn}
                        disabled={isDisputeClosed}
                        onClick={async () => {
                          await dispatch(shareDecision(item.id));
                          closeModal();
                        }}
                      >
                        Share
                      </Button>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      size="small"
                      aria-label="delete document"
                      disabled={isDisputeClosed}
                      onClick={async () => {
                        await deleteDecisionId(item.id);
                        closeModal();
                      }}
                    >
                      <DeleteOutlineIcon
                        fontSize="small"
                        style={{
                          color: isDisputeClosed ? undefined : "#C62828",
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  function completepayment(disputeId) {
    return async () => {
      try {
        let response = await instance({
          method: "get",
          url: `/completepayment/${disputeId}/`,
        });
        return response.data;
      } catch (error) {
        console.log("error.request.status", error.request.status);
        console.log("error.message", error.message);
      }
    };
  }
  const handlePayment = () => {
    dispatch(completepayment(dispute.id)).then(() => {
      refresh();
    });
  };

  const removeTempEmail = (profile) => {
    if (!profile?.user) return profile;

    const email = profile.user.email;
    return {
      ...profile,
      user: {
        ...profile.user,
        email: isNalsarTempEmail(email) ? '' : email,
      }
    };
  };

  if (loading) {
    return <CircularCenteredLoader />;
  } else {
    return (
      <Grid
        container
        justify="flex-start"
        direction="column"
        style={{ padding: "1rem" }}
      >
        <Grid item>
          <Grid container justify="space-between">
            <Grid item>
              <Button
                onClick={() => {
                  setOpenCase(false);
                  sessionStorage.removeItem("tiac_overview_caseid");
                }}
                className={classes.backbtn}
                startIcon={<ArrowBackIosIcon />}
              >
                Back to all cases
              </Button>
            </Grid>
            <Grid item>
              <Typography className={classes.username}>
                {profile.user.first_name} {profile.user.last_name}
              </Typography>
            </Grid>
          </Grid>
          <Box height="2rem"></Box>
          {/* {!isSmallScreen() ? ( */}
          <>
            <Grid
              container
              direction="row"
              alignItems="stretch"
              style={{ display: "flex" }}
              spacing={2}
            >
              <Grid item sm={10} xs={12} style={{ flex: "1" }}>
                <Paper
                  style={{
                    height: "100%",
                    background: "none",
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  <Grid container justify="space-between">
                    <Grid item>
                      <Typography className={classes.blackheading}>
                        CASE ID:{" "}
                        {dispute.approved ? (
                          isSebi || isMSME ? (
                            <CaseAssignInput
                              tiac_custom_dispute_id={
                                dispute.tiac_custom_dispute_id
                              }
                              caseId={caseId}
                            />
                          ) : (
                            dispute.tiac_custom_dispute_id
                          )
                        ) : (
                          "---"
                        )}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography className={classes.blackheading}>
                        Start Date: {startDate}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography className={classes.blackheading}>
                        Registration Date: {approvedDate}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
            <Grid
              container
              justify="space-evenly"
              direction="row"
              alignItems="stretch"
              // style={{ display: "flex" }}
              spacing={3}
            >
              <Grid item md={7} sm={8} xs={12}>
                <Summary summary={summary} caseId={caseId} isDisputeClosed={isDisputeClosed} />
              </Grid>
              <Grid item md={5} sm={4} xs={9}>
                <Grid
                  container
                  direction="column"
                  justify="space-evenly"
                  spacing={2}
                >
                  <Grid item style={{ width: "90%" }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      className={classes.bigbtn}
                      style={
                        isDisputeClosed ||
                        !dispute.approved ||
                        (dispute.rv_tiac_payment_status != "complete" &&
                          !(isSebi || isMSME))
                          ? {
                              width: "100%",
                              background: "rgba(0,0,0,0.12)",
                              color: "rgba(0,0,0,0.26)",
                            }
                          : {
                              width: "100%",
                              background: "#2F80ED",
                              color: "#fff",
                            }
                      }
                      onClick={() => {
                        history.push(`/disputes/${caseId}/chat`);
                      }}
                      disabled={
                        isDisputeClosed ||
                        !dispute.approved ||
                        (dispute.rv_tiac_payment_status != "complete" &&
                          !(isSebi || isMSME))
                      }
                    >
                      <FormattedMessage id="common.hearingRooms" />
                    </Button>
                  </Grid>
                  <Grid item style={{ width: "90%" }}>
                    <Button
                      variant="contained"
                      // color="primary"
                      className={classes.bigbtn}
                      size="large"
                      style={{
                        color: "black",
                        background: "white",
                        width: "100%",
                        textTransform: "none",
                      }}
                      onClick={() => {
                        openpopup3();
                        // history.push(`/disputes/${activeDispute.id}/chat`);
                      }}
                    >
                      Details &amp; Updates
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
          <Box height="4rem"></Box>
          <Grid container justify="flex-start" spacing={2} wrap="wrap">
            {complainantData.length == 0 && (
              <Grid
                item
                sm={6}
                md={6}
                lg={4}
                style={{ width: "100%", display: "flex" }}
              >
                <Complainant
                  isSmallScreen={isSmallScreen}
                  groData={null}
                  caseId={caseId}
                  mode={mode}
                  index={null}
                  refresh={refresh}
                  lawyerDataRV={lawyerDataRV}
                  allAssignedPrifiles={allAssignedPrifiles}
                  dispute={dispute}
                  casefiles={casefiles}
                  updateDisputeName={updateDisputeName}
                  group={profile.group}
                  isDisputeClosed={isDisputeClosed}
                />
              </Grid>
            )}
            {complainantData.map((complainant, index) => {
              return (
                <Grid
                  item
                  sm={6}
                  md={6}
                  lg={4}
                  style={{ width: "100%", display: "flex" }}
                  key={index}
                >
                  <Complainant
                    isSmallScreen={isSmallScreen}
                    groData={removeTempEmail(complainant)}
                    caseId={caseId}
                    mode={mode}
                    index={index}
                    refresh={refresh}
                    lawyerDataRV={lawyerDataRV}
                    allAssignedPrifiles={allAssignedPrifiles}
                    dispute={dispute}
                    updateDisputeName={updateDisputeName}
                    casefiles={casefiles}
                    group={profile.group}
                    isDisputeClosed={isDisputeClosed}
                  />
                </Grid>
              );
            })}
            {companyData.length == 0 && (
              <Grid
                item
                sm={6}
                md={6}
                lg={4}
                style={{ width: "100%", display: "flex" }}
              >
                <Company
                  isSmallScreen={isSmallScreen}
                  groData={null}
                  caseId={caseId}
                  mode={mode}
                  index={null}
                  refresh={refresh}
                  lawyerDataRV={lawyerDataRV}
                  allAssignedPrifiles={allAssignedPrifiles}
                  dispute={dispute}
                  updateDisputeName={updateDisputeName}
                  casefiles={casefiles}
                  group={profile.group}
                  isDisputeClosed={isDisputeClosed}
                />
              </Grid>
            )}
            {companyData.map((respondent, index) => {
              return (
                <Grid
                  item
                  sm={6}
                  md={6}
                  lg={4}
                  style={{ width: "100%", display: "flex" }}
                  key={index}
                >
                  <Company
                    isSmallScreen={isSmallScreen}
                    groData={removeTempEmail(respondent)}
                    caseId={caseId}
                    mode={mode}
                    index={index}
                    refresh={refresh}
                    lawyerDataRV={lawyerDataRV}
                    allAssignedPrifiles={allAssignedPrifiles}
                    dispute={dispute}
                    updateDisputeName={updateDisputeName}
                    casefiles={casefiles}
                    group={profile.group}
                    isDisputeClosed={isDisputeClosed}
                  />
                </Grid>
              );
            })}

            {groData.length == 0 && (
              <Grid
                item
                sm={6}
                md={6}
                lg={4}
                style={{ width: "100%", display: "flex" }}
              >
                <GRO
                  isSmallScreen={isSmallScreen}
                  groData={null}
                  preGroData={groData}
                  caseId={caseId}
                  mode={mode}
                  index={null}
                  refresh={refresh}
                  allAssignedPrifiles={allAssignedPrifiles}
                  dispute={dispute}
                  group={profile.group}
                  profileType={MEDIATOR}
                  isDisputeClosed={isDisputeClosed}
                />
              </Grid>
            )}
            {groData.map((item, index) => {
              return (
                <Grid
                  item
                  sm={6}
                  md={6}
                  lg={4}
                  style={{ width: "100%", display: "flex" }}
                  key={index}
                >
                  <GRO
                    isSmallScreen={isSmallScreen}
                    groData={removeTempEmail(item)}
                    preGroData={groData}
                    caseId={caseId}
                    mode={mode}
                    index={index}
                    refresh={refresh}
                    allAssignedPrifiles={allAssignedPrifiles}
                    dispute={dispute}
                    group={profile.group}
                    profileType={MEDIATOR}
                    isDisputeClosed={isDisputeClosed}
                  />
                </Grid>
              );
            })}
            {ClaimantLawyerData.length == 0 && (
              <Grid
                item
                sm={6}
                md={6}
                lg={4}
                style={{ width: "100%", display: "flex" }}
              >
                <SRB
                  isSmallScreen={isSmallScreen}
                  caseId={caseId}
                  groData={null}
                  mode={mode}
                  lawyerDataRV={lawyerDataRV}
                  casefile={casefiles}
                  index={null}
                  refresh={refresh}
                  allAssignedPrifiles={allAssignedPrifiles}
                  dispute={dispute}
                  prevLaw={[]}
                  group={profile.group}
                  isDisputeClosed={isDisputeClosed}
                />
              </Grid>
            )}
            {ClaimantLawyerData.map((clitem, index) => {
              if (
                lawyerData.find(
                  (element) => element.profile.id == clitem.lawyer
                )
              ) {
                let item =
                  lawyerData[
                    lawyerData.findIndex(
                      (element) => element.profile.id == clitem.lawyer
                    )
                  ];
                return (
                  <Grid
                    item
                    sm={6}
                    md={6}
                    lg={4}
                    style={{ width: "100%", display: "flex" }}
                    key={item.profile.id}
                  >
                    <SRB
                      isSmallScreen={isSmallScreen}
                      caseId={caseId}
                      groData={removeTempEmail(item)}
                      mode={mode}
                      lawyerDataRV={lawyerDataRV}
                      casefile={clitem.casefile}
                      index={clitem.index}
                      refresh={refresh}
                      allAssignedPrifiles={allAssignedPrifiles}
                      dispute={dispute}
                      prevLaw={clitem.all}
                      group={profile.group}
                      isDisputeClosed={isDisputeClosed}
                    />
                  </Grid>
                );
              } else {
                return (
                  <Grid
                    item
                    sm={6}
                    md={6}
                    lg={4}
                    style={{ width: "100%", display: "flex" }}
                    key={"empty" + index}
                  >
                    <SRB
                      isSmallScreen={isSmallScreen}
                      caseId={caseId}
                      groData={null}
                      mode={mode}
                      lawyerDataRV={lawyerDataRV}
                      casefile={clitem.casefile}
                      index={clitem.index}
                      refresh={refresh}
                      allAssignedPrifiles={allAssignedPrifiles}
                      dispute={dispute}
                      prevLaw={[]}
                      group={profile.group}
                      isDisputeClosed={isDisputeClosed}
                    />
                  </Grid>
                );
              }
            })}
            {RespondentLawyerData.length == 0 && (
              <Grid
                item
                sm={6}
                md={6}
                lg={4}
                style={{ width: "100%", display: "flex" }}
              >
                <RespondentLawyer
                  isSmallScreen={isSmallScreen}
                  caseId={caseId}
                  groData={null}
                  mode={mode}
                  lawyerDataRV={lawyerDataRV}
                  casefile={casefiles}
                  index={null}
                  refresh={refresh}
                  allAssignedPrifiles={allAssignedPrifiles}
                  dispute={dispute}
                  prevLaw={[]}
                  group={profile.group}
                  isDisputeClosed={isDisputeClosed}
                />
              </Grid>
            )}
            {RespondentLawyerData.map((clitem, index) => {
              if (
                lawyerData.find(
                  (element) => element.profile.id == clitem.lawyer
                )
              ) {
                let item =
                  lawyerData[
                    lawyerData.findIndex(
                      (element) => element.profile.id == clitem.lawyer
                    )
                  ];
                return (
                  <Grid
                    item
                    sm={6}
                    md={6}
                    lg={4}
                    style={{ width: "100%", display: "flex" }}
                    key={item.profile.id}
                  >
                    <RespondentLawyer
                      isSmallScreen={isSmallScreen}
                      caseId={caseId}
                      groData={removeTempEmail(item)}
                      mode={mode}
                      lawyerDataRV={lawyerDataRV}
                      casefile={clitem.casefile}
                      index={clitem.index}
                      refresh={refresh}
                      allAssignedPrifiles={allAssignedPrifiles}
                      dispute={dispute}
                      prevLaw={clitem.all}
                      group={profile.group}
                      isDisputeClosed={isDisputeClosed}
                    />
                  </Grid>
                );
              } else {
                return (
                  <Grid
                    item
                    sm={6}
                    md={6}
                    lg={4}
                    style={{ width: "100%", display: "flex" }}
                    key={"empty" + index}
                  >
                    <RespondentLawyer
                      isSmallScreen={isSmallScreen}
                      caseId={caseId}
                      groData={null}
                      mode={mode}
                      lawyerDataRV={lawyerDataRV}
                      casefile={clitem.casefile}
                      index={clitem.index}
                      refresh={refresh}
                      allAssignedPrifiles={allAssignedPrifiles}
                      dispute={dispute}
                      prevLaw={[]}
                      group={profile.group}
                      isDisputeClosed={isDisputeClosed}
                    />
                  </Grid>
                );
              }
            })}

            {(isSebi || isMSME) && witnessData.length === 0 && (
              <Grid
                item
                sm={6}
                md={6}
                lg={4}
                style={{ width: "100%", display: "flex" }}
              >
                <Witness
                  groData={null}
                  caseId={caseId}
                  mode={mode}
                  index={null}
                  refresh={refresh}
                  dispute={dispute}
                  allAssignedPrifiles={allAssignedPrifiles}
                  casefiles={casefiles}
                  group={profile.group}
                  isDisputeClosed={isDisputeClosed}
                />
              </Grid>
            )}
            {(isSebi || isMSME) &&
              witnessData.map((item, index) => {
                return (
                  <Grid
                    item
                    sm={6}
                    md={6}
                    lg={4}
                    style={{ width: "100%", display: "flex" }}
                  >
                    <Witness
                      groData={item}
                      caseId={caseId}
                      mode={mode}
                      index={index}
                      refresh={refresh}
                      dispute={dispute}
                      allAssignedPrifiles={allAssignedPrifiles}
                      casefiles={casefiles}
                      group={profile.group}
                      isDisputeClosed={isDisputeClosed}
                    />
                  </Grid>
                );
              })}

            {casemanagerData.length == 0 &&
              profile.profile_type == "sub_admin_tiac_rv" && (
                <Grid
                  item
                  sm={6}
                  md={6}
                  lg={4}
                  style={{ width: "100%", display: "flex" }}
                >
                  <CaseManager
                    isSmallScreen={isSmallScreen}
                    groData={null}
                    preGroData={groData}
                    caseId={caseId}
                    mode={mode}
                    index={null}
                    refresh={refresh}
                    allAssignedPrifiles={allAssignedPrifiles}
                    dispute={dispute}
                    group={profile.group}
                    isDisputeClosed={isDisputeClosed}
                  />
                </Grid>
              )}
            {profile.profile_type == "sub_admin_tiac_rv" &&
              casemanagerData.map((item, index) => {
                return (
                  <Grid
                    item
                    sm={6}
                    md={6}
                    lg={4}
                    style={{ width: "100%", display: "flex" }}
                    key={index}
                  >
                    <CaseManager
                      isSmallScreen={isSmallScreen}
                      groData={removeTempEmail(item)}
                      preGroData={groData}
                      caseId={caseId}
                      mode={mode}
                      index={index}
                      refresh={refresh}
                      allAssignedPrifiles={allAssignedPrifiles}
                      dispute={dispute}
                      group={profile.group}
                      isDisputeClosed={isDisputeClosed}
                    />
                  </Grid>
                );
              })}
            {/* <Grid
              item
              sm={6}
              md={6}
              lg={4}
              style={{ width: "100%", display: "flex" }}
            >
              <CaseManager
                isSmallScreen={isSmallScreen}
                casemanagerData={casemanagerData}
                caseId={caseId}
                mode={mode}
                refresh={refresh}
                allAssignedPrifiles={allAssignedPrifiles}
              />
            </Grid> */}
          </Grid>
          <Box height="4rem"></Box>
          <Grid container spacing={2}>
            {(
              <Grid item lg={4} md={6} sm={6} xs={6}>
                <Button
                  variant="contained"
                  // color="primary"
                  className={classes.bigbtn}
                  size="large"
                  style={{
                    color: "black",
                    background: "white",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    openPopupRFA();
                  }}
                >
                  MRF
                </Button>
              </Grid>
            )}
            <Grid item lg={4} md={6} sm={6} xs={6}>
              <Button
                variant="contained"
                // color="primary"
                className={classes.bigbtn}
                size="large"
                style={
                  dispute.approved || isDisputeClosed
                    ? {
                        color: "rgba(0,0,0,0.26)",
                        background: "rgba(0,0,0,0.12)",
                        width: "100%",
                        textTransform: "none",
                      }
                    : {
                        color: "black",
                        background: "white",
                        width: "100%",
                        textTransform: "none",
                      }
                }
                onClick={() => {
                  openpopupRegister();
                }}
                disabled={dispute.approved || isDisputeClosed}
              >
                Register Case
              </Button>
            </Grid>
            <Grid item lg={4} md={6} sm={6} xs={6}>
              <Button
                variant="contained"
                // color="primary"
                className={classes.bigbtn}
                size="large"
                style={{
                  color: "black",
                  background: "white",
                  width: "100%",
                  textTransform: "none",
                }}
                onClick={() => {
                  history.push(`/disputes/${caseId}/files/0`);
                }}
              >
                Files
              </Button>
            </Grid>
            <Grid item lg={4} md={6} sm={6} xs={6}>
              <Button
                variant="contained"
                // color="primary"
                className={classes.bigbtn}
                size="large"
                style={{
                  color: "black",
                  background: "white",
                  width: "100%",
                  textTransform: "none",
                }}
                onClick={() => {
                  openPopupAwardPartial();
                }}
              >
                Partial Award
              </Button>
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={6}>
              <Button
                variant="contained"
                // color="primary"
                className={classes.bigbtn}
                size="large"
                style={{
                  color: "black",
                  background: "white",
                  width: "100%",
                  textTransform: "none",
                }}
                onClick={() => {
                  openPopupAwardFinal();
                }}
              >
                Final Award
              </Button>
            </Grid>
            {(isSebi || isMSME) && (
              <Grid item lg={4} md={6} sm={6} xs={6}>
                <Button
                  variant="contained"
                  // color="primary"
                  className={classes.bigbtn}
                  size="large"
                  style={
                    dispute.flow_type != "mediation" || isDisputeClosed
                      ? {
                          color: "rgba(0,0,0,0.26)",
                          background: "rgba(0,0,0,0.12)",
                          width: "100%",
                          textTransform: "none",
                        }
                      : {
                          color: "black",
                          background: "white",
                          width: "100%",
                          textTransform: "none",
                        }
                  }
                  onClick={handleMoveToArbitration}
                  disabled={dispute.flow_type != "mediation" || isDisputeClosed}
                >
                  Move to Arbitration
                </Button>
              </Grid>
            )}
            <Grid item lg={4} md={6} sm={6} xs={6}>
              <Button
                variant="contained"
                // color="primary"
                className={classes.bigbtn}
                size="large"
                style={
                  isDisputeClosed
                    ? {
                        color: "rgba(0,0,0,0.26)",
                        background: "rgba(0,0,0,0.12)",
                        width: "100%",
                        textTransform: "none",
                      }
                    : {
                        color: "black",
                        background: "white",
                        width: "100%",
                        textTransform: "none",
                      }
                }
                onClick={() => {
                  openpopup2();
                }}
                disabled={isDisputeClosed}
              >
                Close Case
              </Button>
            </Grid>
            {!isSebi && !isMSME && (
              <Grid item lg={4} md={6} sm={6} xs={6}>
                <Button
                  variant="contained"
                  // color="primary"
                  className={classes.bigbtn}
                  size="large"
                  style={
                    dispute.rv_tiac_payment_status == "complete" || isDisputeClosed
                      ? {
                          color: "rgba(0,0,0,0.26)",
                          background: "rgba(0,0,0,0.12)",
                          width: "100%",
                          textTransform: "none",
                        }
                      : {
                          color: "black",
                          background: "white",
                          width: "100%",
                          textTransform: "none",
                        }
                  }
                  onClick={handlePayment}
                  disabled={dispute.rv_tiac_payment_status == "complete" || isDisputeClosed}
                >
                  {dispute.rv_tiac_payment_status == "complete"
                    ? "Payment Completed"
                    : "Complete Payment"}
                </Button>
              </Grid>
            )}
          </Grid>
          <Box height="5rem"></Box>
          <Grid container justify="flex-start">
            <Grid item sm={3} xs={3}>
              <Typography className={classes.blueheading}>NAME</Typography>
            </Grid>
            <Grid item sm={3} xs={3}>
              <Typography className={classes.blueheading}>
                PROFILE TYPE
              </Typography>
            </Grid>
            <Grid item sm={3} xs={3}>
              <Typography className={classes.blueheading}>CALENDAR</Typography>
            </Grid>
            <Grid item sm={3} xs={3}>
              <Typography className={classes.blueheading}>DRIVE</Typography>
            </Grid>
          </Grid>
          <Box height="0.4rem"></Box>
          {allProfiles.map((profile) => {
            return (
              <CaseDisplayProfileList
                key={profile.profile.id}
                profile={profile}
                caseId={caseId}
                mode={mode}
              />
            );
          })}
        </Grid>

        <Box height="2rem" />
        <Grid container>
          <Grid item md={10} sm={11} xs={12}>
            <GeneralSebiActivities
              activities={activities}
              setActivities={setActivities}
              isGetActivityByTabAndId={true}
              disputeId={caseId}
              activityTitle="Case Activity"
            />
            <Box height="2rem" />
          </Grid>
        </Grid>

        <Popup
          open={openRegister}
          closeOnDocumentClick={!loadingRegisterApi}
          closeOnEscape={!loadingRegisterApi}
          onClose={closeModalRegister}
          position="center"
          modal
          nested
          contentStyle={{
            background: "white",
            width: "330px",
            height: "185px",
          }}
          overlayStyle={{ background: "rgba(51, 51, 51, 0.7)" }}
        >
          <Box style={{ padding: "1rem 1.3rem" }}>
            <Typography
              style={{
                fontSize: "20px",
                color: "#333333",
                "font-weight": "bold",
                "line-height": "23px",
                "letter-spacing": "0.0015em",
              }}
            >
              Are you sure?
            </Typography>
            <Box height="0.5rem"></Box>
            <Typography
              style={{
                fontSize: "16px",
                color: "#828282",
                "line-height": "28px",
              }}
            >
              Are you sure you want to register this case?
            </Typography>
            <Box height="0.7rem"></Box>
          </Box>
          <Box style={{ padding: "1rem 1.3rem" }}>
            <Grid container direction="row" justify="flex-end" spacing={2}>
              <Grid item>
                <Typography
                  style={{
                    fontSize: "14px",
                    color: "#828282",
                    "line-height": "16px",
                    "letter-spacing": "0.02em",
                    "font-weight": "500",
                    cursor: loadingRegisterApi ? "not-allowed" : "pointer",
                    opacity: loadingRegisterApi ? 0.5 : 1,
                  }}
                  onClick={() => {
                    if (!loadingRegisterApi) closeModalRegister();
                  }}
                >
                  CANCEL
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  style={{
                    fontSize: "14px",
                    color: "#2F80ED",
                    "line-height": "16px",
                    "letter-spacing": "0.02em",
                    "font-weight": "500",
                    cursor: loadingRegisterApi ? "not-allowed" : "pointer",
                  }}
                  onClick={ApproveDispute}
                >
                  {loadingRegisterApi ? (
                    <CircularProgress size={16} />
                  ) : (
                    "REGISTER"
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Popup>
        <Popup
          open={open2}
          closeOnDocumentClick
          closeOnEscape
          onClose={closeModal2}
          position="center"
          modal
          nested
          contentStyle={
            isSebi || isMSME
              ? {
                  background: "white",
                  width: "330px",
                  height: "auto",
                }
              : {
                  background: "white",
                  width: "330px",
                  height: "185px",
                }
          }
          overlayStyle={{ background: "rgba(51, 51, 51, 0.7)" }}
        >
          <Box style={{ padding: "1rem 1.3rem" }}>
            <Typography
              style={{
                fontSize: "20px",
                color: "#333333",
                "font-weight": "bold",
                "line-height": "23px",
                "letter-spacing": "0.0015em",
              }}
            >
              Are you sure?
            </Typography>
            <Box height="0.5rem"></Box>
            <Typography
              style={{
                fontSize: "16px",
                color: "#828282",
                "line-height": "28px",
              }}
            >
              Are you sure you want to close this case?
            </Typography>
            <Box height="0.7rem"></Box>
            {(isSebi || isMSME) && (
              <>
                <Typography
                  style={{
                    fontSize: "16px",
                    color: "#828282",
                    "line-height": "28px",
                  }}
                >
                  Mark case as successful, unsuccessful or withdrawn
                </Typography>
                <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                  <FormControl variant="outlined" data-testid={dispute.id}>
                    <InputLabel id="sadf">Select</InputLabel>
                    <Select
                      id={dispute.id}
                      name={dispute.id}
                      value={successState}
                      onChange={handleSuccessStateChange}
                      label="Select"
                      style={{ textAlign: "left" }}
                    >
                      {closed_reason_choices.map((item) => {
                        return (
                          <MenuItem
                            id={item.value}
                            value={item.value}
                            style={{ whiteSpace: "pre-wrap" }}
                          >
                            {item.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  {isSebi && dispute?.flow_type == 'mediation' && (
                    <FormControl variant="outlined" style={{width: '100px'}}>
                    <InputLabel id="sadf">Select</InputLabel>
                    <Select
                      labelId="select-label"
                      value={selectedUserId}
                      onChange={handleSelectUserId}
                      label="Select"
                      style={{ textAlign: "right" }}
                    >
                      {allProfiles?.map((profileName) => {
                        return (
                          <MenuItem
                            id={profileName?.user?.id}
                            value={profileName?.user?.id}
                            style={{ whiteSpace: "pre-wrap" }}
                          >
                            {profileName?.user?.first_name} {profileName?.user?.last_name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    </FormControl>
                  )}
                </div>
              </>
            )}
          </Box>
          <Box style={{ padding: "1rem 1.3rem" }}>
            <Grid container direction="row" justify="flex-end" spacing={2}>
              <Grid item>
                <Typography
                  style={{
                    fontSize: "14px",
                    color: "#828282",
                    "line-height": "16px",
                    "letter-spacing": "0.02em",
                    "font-weight": "500",
                    cursor: "pointer",
                  }}
                  onClick={closeModal2}
                >
                  CANCEL
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  style={{
                    fontSize: "14px",
                    color: "#2F80ED",
                    "line-height": "16px",
                    "letter-spacing": "0.02em",
                    "font-weight": "500",
                    cursor: loadingCaseClose ? "not-allowed" : "pointer",
                  }}
                  onClick={closeGrievence}
                >
                  {loadingCaseClose ? <CircularProgress size={16}/> : 'CLOSE'}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Popup>
        <Popup
          open={open3}
          closeOnDocumentClick
          closeOnEscape
          onClose={closeModal3}
          position="center"
          modal
          nested
          contentStyle={{
            background: "white",
            width: "400px",
            // height: "170px",
            textAlign: "left",
          }}
          overlayStyle={{ background: "rgba(51, 51, 51, 0.7)" }}
        >
          <Box style={{ padding: "1rem 1.3rem" }}>
            <Typography
              style={{
                fontSize: "16px",
                color: "#828282",
                "line-height": "28px",
                textAlign: "left",
                paddingTop: " 1.3rem",
              }}
            >
              Claimant Status :
              <br />
              {dispute.rv_arbitrator_step_complete
                ? "Mediator choose step : Complete"
                : "Mediator choose step : Incomplete"}
              <br />
              {dispute.rv_claimant_lawyer_step_complete
                ? "Counsel choose step : Complete"
                : "Counsel choose step : Incomplete"}
              <br />
              {dispute.rv_respondent_choose_step_complete
                ? "Respondent choose step : Complete"
                : "Respondent choose step : Incomplete"}
              <br />
            </Typography>
            <Typography
              style={{
                fontSize: "16px",
                color: "#828282",
                "line-height": "28px",
                textAlign: "left",
                paddingTop: " 1.3rem",
              }}
            >
              Respondent Status :
              <br />
              {dispute.rv_respondent_lawyer_step_complete
                ? "Counsel choose step : Complete"
                : "Counsel choose step : Incomplete"}
            </Typography>
          </Box>
        </Popup>
        <Modal
          open={openAwardFinal}
          onClose={closeAwardFinal}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          disableEnforceFocus
        >
          <Fade in={openAwardFinal}>
            <Paper className={classes.awardModalPaper}>
              <CloseModalButton onClick={closeAwardFinal} />
              <Typography className={classes.awardModalTitle}>
                Final Awards
              </Typography>
              {renderAwardsTable("final_award", closeAwardFinal)}
              {renderAwardUpload("final_award")}
            </Paper>
          </Fade>
        </Modal>
        <Modal
          open={openAwardPartial}
          onClose={closeAwardPartial}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          disableEnforceFocus
        >
          <Fade in={openAwardPartial}>
            <Paper className={classes.awardModalPaper}>
              <CloseModalButton onClick={closeAwardPartial} />
              <Typography className={classes.awardModalTitle}>
                Partial Awards
              </Typography>
              {renderAwardsTable("partial_award", closeAwardPartial)}
              {renderAwardUpload("partial_award")}
            </Paper>
          </Fade>
        </Modal>
        <Modal
          open={openRFA}
          onClose={closeRFA}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          disableEnforceFocus
        >
          <Fade in={openRFA}>
            <Paper className={classes.awardpaper}>
              <CloseModalButton onClick={closeRFA} />
              <Typography
                style={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                MRF
              </Typography>
              <Box height="1rem" />
              {commonFiles.map((item) => {
                if (item.is_rfa_rv && item.award_type == "partial_award")
                  return (
                    <React.Fragment key={item.id}>
                      <Grid container>
                        <Grid item xs={12}>
                          <MenuItem
                            onClick={() => {
                              downloadLegalDoc(item.id);
                            }}
                          >
                            {"Arbitration agreement" + "_" + item.name}
                          </MenuItem>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  );
                else if (item.is_rfa_rv && item.award_type == "final_award")
                  return (
                    <React.Fragment key={item.id}>
                      <Grid container>
                        <Grid item xs={12}>
                          <MenuItem
                            onClick={() => {
                              downloadLegalDoc(item.id);
                            }}
                          >
                            {"Contract" + "_" + item.name}
                          </MenuItem>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  );
                else if (item.is_rfa_rv)
                  return (
                    <React.Fragment key={item.id}>
                      <Grid container>
                        <Grid item xs={12}>
                          <MenuItem
                            onClick={() => {
                              downloadLegalDoc(item.id);
                            }}
                          >
                            {item.name}
                          </MenuItem>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  );
              })}
            </Paper>
          </Fade>
        </Modal>
      </Grid>
    );
  }
}
